import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NewLabelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"new_label"}/>
}
